import React, { useState, useRef } from 'react';
//import 'bootstrap/dist/css/bootstrap.min.css';
import { pinagareAPIURL } from '../../Constant';
import { trackPromise } from 'react-promise-tracker';
import { ToastContainer, toast } from "react-toastify";

function SingleUpload(props) {
	
	const [selectedFile, setSelectedFile] = useState(null);

	const [imageLink, setImageLink] = useState(null);

	const [validationError, setValidationError] = useState(null);

	const fileInputRef = useRef(null);

	const handleFileChange = (event) => {

		const file = event.target.files[0];
		if(file)
		{
			const allowedExtension = ['.jpg', '.pdf'];
			const selectedFileExtension = file.name.split('.').pop().toLowerCase();
			if(allowedExtension.includes('.' + selectedFileExtension))
			{
				setSelectedFile(file);
				setValidationError(null);
			}
			else
			{
				setSelectedFile(null);
				setValidationError('Invalid file extension. Please select a file with .jpg or .png extension.');
				fileInputRef.current.value = '';
			}
		}

	};

	const handleUpload = async(e) => {
        e.preventDefault();
		if(selectedFile)
		{
			const formData = new FormData();
			formData.append('file', selectedFile);
            
            formData.append('eng', "upload_pinagare_file");
            formData.append('efe', props.eng);

			const response = await fetch('http://localhost/pinagare/backend/upload.php', {
				method : 'POST',
				body : formData
			});

			const responseData = await response.json();
			setImageLink(responseData.image_link);
			fileInputRef.current.value = '';

            if(responseData.status!=null&&responseData.status!=undefined&&responseData.status){
                toast.success(responseData.message);
                //setStatus('success');
              }
              else{
                if(responseData.status!=null&&responseData.status!=undefined){
                  toast.error(responseData.message);
                }
                else{
                toast.error("Ooops..an internal error occurred. Please try again shortly");
                }
                //setStatus('fail');
              }
		}
		else
		{
			setValidationError('Please select a file before uploading.');
            toast.success("file failed");
		}
	};

	return (
		<div className="container">
            
            <div className="card">
                
                <div className="card-body">
                    <div className="row">
                        <div className="col col-2"><b>Select File</b></div>
                        <div className="col col-3">
                        	<input type="file" ref={fileInputRef} onChange={handleFileChange} />
                        </div>
                        <div className="col col-3">
                        	<button className="btn btn-primary" onClick={handleUpload}>Upload</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-2">&nbsp;</div>
                        <div className="col col-3">
                            {validationError && (
                            	<p className="text-danger">{validationError}</p>
                            )}

                            {imageLink && (
                            	<div>
                                    <p><b>Uploaded Image : </b></p>
                                    <img src={imageLink} className="img-fluid img-thumbnail" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
	)
}

export default SingleUpload